import React from "react";

import { ChunkLoadErrorBoundary } from "components/error-boundary/ErrorBoundary";
import { MainRoutes } from "routes";

export const App = () => {
  return (
    <ChunkLoadErrorBoundary>
      <MainRoutes />
    </ChunkLoadErrorBoundary>
  );
};
